export default __webpack_public_path__ + "576c13e242607d5d64db03f8404d11a7.webp";